export enum StatusCourseEnum {
  InProgress = 0, //Progreso
  Pending = 1, //Disponible
  Failed = 2, //Progreso
  Completed = 3, //Completado
  CourseFailed = 4, //Progreso
  ReinforcementPending = 5, //Disponible
  ReinforcementInProgress = 6, //Progreso
  ReinforcementFailed = 7, //Progreso
}
